module.exports = __webpack_public_path__ + "img/36.860f448f.jpg";